import axios from 'axios';
import { encode as base64_encode } from 'base-64';
import React from 'react';
import AgeGroup from '../../components/AgeGroup/AgeGroup';
import HeaderPage from '../../components/PageHeader/PageHeader';
import StepCounter from '../../components/StepCounter/StepCounter';
import { retornarCookie } from '../../services/cookieservice';
import {
  listarAgregados,
  listarArquivos,
  listarInativos,
  listarPatologiasOportunidade,
  listarReembolsosOportunidade,
} from '../../services/nivel2service';
import './GerarPropostaPage.css';
import Loader from '../../components/Loader/Loader';


const { REACT_APP_API, REACT_APP_URL_INSTANCE } = process.env;

export default class GerarPropostaPage extends React.Component {
  state = {
    oportunidadeId: undefined,
    oportunidade: undefined,
    elegibilidades: [],
    nivel2Resumo: {
      carregado: false,
      patologias: [],
      inativos: [],
      agregados: [],
      arquivos: [],
      reembolsos: [],
    },
    totalVidas: undefined,
    alerta59Anos: 'NAO',
    exibeCarregamento : false,
  };

  isTruthy = (valor) =>
    valor === true || valor === 1 || valor === '1' || valor === 'true' || valor === 'True';

  isNivel2Opportunity = (oportunidade) => {
    const nivelRaw = oportunidade?.NivelOportunidade ?? oportunidade?.nivelOportunidade;
    const qtdeVidasRaw = oportunidade?.QtdeVidas ?? oportunidade?.qtdeVidas;
    const nivel = Number(nivelRaw);
    const qtdeVidas = Number(qtdeVidasRaw);

    return (
      nivel === 2 ||
      (!Number.isNaN(qtdeVidas) && qtdeVidas >= 30 && qtdeVidas <= 99)
    );
  };

  formatarData = (valor) => {
    const texto = (valor || '').toString().trim();
    const matchIso = texto.match(/^(\d{4})-(\d{2})-(\d{2})(?:[T\s].*)?$/);
    if (matchIso) {
      return `${matchIso[3]}/${matchIso[2]}/${matchIso[1]}`;
    }

    return texto;
  };

  formatarMoeda = (valor) => {
    const numero = Number(valor);
    if (Number.isNaN(numero)) {
      return '-';
    }

    return numero.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    });
  };

  getQuantidadeDistribuicao = (oportunidade, tipo) => {
    const candidatosPorTipo = {
      CLT: [
        oportunidade?.QtdeVidasCLT,
        oportunidade?.QtdVidasCLT,
        oportunidade?.qtdeVidasCLT,
        oportunidade?.qtdVidasCLT,
        oportunidade?.qtdeVidasClt,
        oportunidade?.qtdVidasClt,
      ],
      PSPJ: [
        oportunidade?.QtdeVidasPSPJ,
        oportunidade?.QtdVidasPSPJ,
        oportunidade?.qtdeVidasPSPJ,
        oportunidade?.qtdVidasPSPJ,
        oportunidade?.qtdeVidasPspj,
        oportunidade?.qtdVidasPspj,
      ],
      Socios: [
        oportunidade?.QtdeVidasSocios,
        oportunidade?.QtdVidasSocios,
        oportunidade?.qtdeVidasSocios,
        oportunidade?.qtdVidasSocios,
      ],
    };

    const valor = (candidatosPorTipo[tipo] || []).find(
      (item) => item !== undefined && item !== null && item !== ''
    );
    const numero = Number(valor);

    return Number.isNaN(numero) ? 0 : numero;
  };

  getPatologiaRegistroId = (patologia) => patologia?.Id || patologia?.id;

  getArquivosDaPatologia = (patologia) => {
    const patologiaId = this.getPatologiaRegistroId(patologia);
    const patologiaNome = (patologia?.PatologiaNome || patologia?.patologiaNome || '').toString().trim();

    return (this.state.nivel2Resumo.arquivos || []).filter((arquivo) => {
      const arquivoPatologiaId = arquivo?.PatologiaId || arquivo?.patologiaId;
      if (arquivoPatologiaId !== undefined && arquivoPatologiaId !== null && patologiaId) {
        return String(arquivoPatologiaId) === String(patologiaId);
      }

      const arquivoPatologiaNome = (arquivo?.PatologiaNome || arquivo?.patologiaNome || '').toString().trim();
      return !!patologiaNome && arquivoPatologiaNome === patologiaNome;
    });
  };

  agruparReembolsosPorPlano = (reembolsos) => {
    const grupos = {};

    (reembolsos || []).forEach((item) => {
      const planoId = item?.PlanoCrmId || item?.planoCrmId || item?.PlanoId || item?.planoId || 'sem-plano';
      const planoNome = item?.PlanoNome || item?.planoNome || item?.Plano || item?.plano || `Plano ${planoId}`;

      if (!grupos[planoId]) {
        grupos[planoId] = {
          planoId,
          planoNome,
          itens: [],
        };
      }

      grupos[planoId].itens.push(item);
    });

    return Object.values(grupos);
  };

  carregarResumoNivel2 = async (oportunidadeID) => {
    const [patologias, inativos, agregados, arquivos, reembolsos] = await Promise.all([
      listarPatologiasOportunidade(oportunidadeID).catch(() => []),
      listarInativos(oportunidadeID).catch(() => []),
      listarAgregados(oportunidadeID).catch(() => []),
      listarArquivos(oportunidadeID).catch(() => []),
      listarReembolsosOportunidade(oportunidadeID).catch(() => []),
    ]);

    this.setState({
      nivel2Resumo: {
        carregado: true,
        patologias: patologias || [],
        inativos: inativos || [],
        agregados: agregados || [],
        arquivos: arquivos || [],
        reembolsos: reembolsos || [],
      },
    });
  };

  ValidarVidas59Anos = async (OportunidadeId) => {

      axios.defaults.headers.get['Access-Control-Allow-Origin'] = '*';
      await axios
        .get(
          `${REACT_APP_API}oportunidade/VerificarFaixasEtariasElevadas?oportunidadeID=${OportunidadeId}`
        )
        .then((res) => {
          const alerta59Anos = res.data;

          this.setState({ alerta59Anos });
        });
    
  };

  componentDidMount() {
    
    const urlParams = new URLSearchParams(window.location.search);
    
    const oportunidadeId = urlParams.get('OportunidadeID');

    this.ValidarVidas59Anos(oportunidadeId);
  
    this.setState({ oportunidadeId });
    this.carregarOportunidade(oportunidadeId);
    this.carregarElegibilidades(oportunidadeId);
  }

  carregarOportunidade = async (oportunidadeID) => {
    const params = {
      oportunidadeID,
      IdAgenteVendas: retornarCookie('IdAgenteVenda'),
      CdAgenteVendas: retornarCookie('CdAgenteVendas'),
      multiplasPropostas: false,
    };

    axios.get(`${REACT_APP_API}oportunidade/OportunidadePorId`, { params }).then((res) => {
      const oportunidade = res.data;
      this.setState({ oportunidade });

      if (this.isNivel2Opportunity(oportunidade)) {
        this.carregarResumoNivel2(oportunidadeID);
      }
    });
  };

  async carregarElegibilidades(oportunidadeID) {
    this.setState({exibeCarregamento : true})

    const IdAgenteVendas = retornarCookie('IdAgenteVenda');

    const params = {
      oportunidadeID,
      IdAgenteVendas,
    };

    axios.get(`${REACT_APP_API}elegibilidade/elegibilidadesCompleta`, { params }).then((res) => {
      const elegibilidades = [...res.data];
      let totalVidas = 0;

      elegibilidades.forEach((x) => {
        totalVidas += x.QtdeVidasTotal;
      });

      this.setState({ elegibilidades, totalVidas });
      this.setState({exibeCarregamento : false})
    });
  }

  async gerarProposta() {
    this.setState({exibeCarregamento : true})

    if(this.state.alerta59Anos.retorno === 'SIM'){
      alert(this.state.alerta59Anos.mensagem);
    }

    const IdAgenteVendas = retornarCookie('IdAgenteVenda');

    axios.put(`${REACT_APP_API}oportunidade/GerarProposta/${this.state.oportunidadeId}/${IdAgenteVendas}`).then((res) => {
      const redirectTo = `${REACT_APP_URL_INSTANCE}${base64_encode('NavigationBar,FinalizacaoOportunidadePage')}`;
      const auth = `&Auth=${base64_encode(retornarCookie('Auth'))}`;

      document.location.href = `${redirectTo}${auth}&OportunidadeID=${this.state.oportunidadeId}`;
    });
  }

  async voltar() {
    const ehNivel2 = this.isNivel2Opportunity(this.state.oportunidade);
    const reembolsoRaw =
      this.state.oportunidade?.ReembolsoDiferenciado ?? this.state.oportunidade?.reembolsoDiferenciado;
    const hasReembolso =
      this.isTruthy(reembolsoRaw);

    const redirectTo = ehNivel2 && hasReembolso
      ? `${REACT_APP_URL_INSTANCE}${base64_encode('NavigationBar,ReembolsoNivel2Page')}`
      : `${REACT_APP_URL_INSTANCE}${base64_encode('NavigationBar,ElegibilidadePage')}`;
    const params = `&OportunidadeID=${this.state.oportunidadeId}`;
    const auth = `&Auth=${base64_encode(retornarCookie('Auth'))}`;

    document.location.href = `${redirectTo}${params}${auth}`;
  }

  render() {
    const { elegibilidades, totalVidas, oportunidade, nivel2Resumo } = { ...this.state };
    const ehNivel2 = this.isNivel2Opportunity(oportunidade);
    const reembolsoRaw = oportunidade?.ReembolsoDiferenciado ?? oportunidade?.reembolsoDiferenciado;
    const hasReembolso = this.isTruthy(reembolsoRaw);
    const reembolsosPorPlano = this.agruparReembolsosPorPlano(nivel2Resumo.reembolsos);
    const exibirResumoReembolso = hasReembolso || nivel2Resumo.reembolsos.length > 0;
    const qtdeVidasCLT = this.getQuantidadeDistribuicao(oportunidade, 'CLT');
    const qtdeVidasPSPJ = this.getQuantidadeDistribuicao(oportunidade, 'PSPJ');
    const qtdeVidasSocios = this.getQuantidadeDistribuicao(oportunidade, 'Socios');

    const passoAtual = () => {
      const isNivel2 = ehNivel2;
      const isFilial3 = retornarCookie('Filial') === '3';
      const hasReembolso = this.isTruthy(reembolsoRaw);

      if (!isNivel2) {
        return <StepCounter step="4" total="4" />;
      }

      if (isFilial3) {
        return <StepCounter step="5" total="5" />;
      }

      return <StepCounter step={hasReembolso ? "6" : "5"} total={hasReembolso ? "6" : "5"} />;
    }

    return (
      <div className="fade-in">
        {this.state.exibeCarregamento && <Loader/>}
        <div className="row container">
          <div className="col s9 m9 l9">
            <br />
            <b>
              <h5>Nova Oportunidade</h5>
            </b>
          </div>
          <div className="col s3 m3 l3">
            <br />
            {passoAtual()}
          </div>
        </div>
        <div className="row container">
          <HeaderPage
            Spotlight="Gerar"
            Title="Proposta"
            Description="Confira se todas as informações estão corretas e gere a proposta para análise."
          />

          <div className="col s5 m5 l5 offset-s3 offset-m3 offset-l3">
            {elegibilidades.length > 0 &&
              elegibilidades.map((elegibilidade) => (
                <>
                  <div className="input-field col s12">
                    <label for="nomeElegibilidade">{elegibilidade.Nome}</label>
                    <input id="nomeElegibilidade" disabled type="text" name="nomeElegibilidade" />
                  </div>
                  {elegibilidade.Planos.length &&
                    elegibilidade.Planos.map((plano) => (
                      <div className="input-field col s12">
                        <label for="plano">{plano.NomePlano}</label>
                        <input id="plano" type="text" disabled name="plano" />
                      </div>
                    ))}
                  <div className="input-field col s12">
                    Quantidade de beneficiário por idade:
                    <br />
                    &nbsp;
                    {elegibilidade.FaixasEtariasVidas.length > 0 &&
                      elegibilidade.FaixasEtariasVidas.map((faixa) => (
                        <AgeGroup description={faixa.NomeFaixaEtaria} data={faixa.QtdeVidasDistribuidsaFaixaEtaria} />
                      ))}
                  </div>
                </>
              ))}

            {ehNivel2 && (
              <div className="gerar-proposta-nivel2">
                <h6 className="gerar-proposta-nivel2-title">Informações Nível 2</h6>

                <details className="gerar-proposta-accordion" open>
                  <summary>
                    Distribuição e sinalizadores
                  </summary>
                  <div className="gerar-proposta-accordion-body">
                    <div><b>CLT:</b> {qtdeVidasCLT}</div>
                    <div><b>PS/PJ:</b> {qtdeVidasPSPJ}</div>
                    <div><b>Sócios:</b> {qtdeVidasSocios}</div>
                    <div><b>Possui patologias:</b> {this.isTruthy(oportunidade?.PossuiPatologias) || nivel2Resumo.patologias.length > 0 ? 'Sim' : 'Não'}</div>
                    <div><b>Possui inativos:</b> {this.isTruthy(oportunidade?.PossuiInativos) || nivel2Resumo.inativos.length > 0 ? 'Sim' : 'Não'}</div>
                    <div><b>Possui agregados:</b> {this.isTruthy(oportunidade?.PossuiAgregados) || nivel2Resumo.agregados.length > 0 ? 'Sim' : 'Não'}</div>
                    <div><b>Reembolso diferenciado:</b> {exibirResumoReembolso ? 'Sim' : 'Não'}</div>
                  </div>
                </details>

                <details className="gerar-proposta-accordion">
                  <summary>
                    Patologias ({nivel2Resumo.patologias.length})
                  </summary>
                  <div className="gerar-proposta-accordion-body">
                    {nivel2Resumo.patologias.length > 0 ? (
                      nivel2Resumo.patologias.map((item) => {
                        const arquivos = this.getArquivosDaPatologia(item);

                        return (
                          <div className="gerar-proposta-item" key={item.Id || item.id}>
                            <div><b>Patologia:</b> {item.PatologiaNome || item.patologiaNome}</div>
                            <div><b>Qtd. vidas:</b> {item.QtdeVidas || item.qtdeVidas || 0}</div>
                            <div><b>Arquivos:</b> {arquivos.length > 0 ? arquivos.map((arquivo) => arquivo.NomeArquivo || arquivo.nomeArquivo).join(', ') : 'Nenhum arquivo anexado'}</div>
                          </div>
                        );
                      })
                    ) : (
                      <div>Nenhuma patologia informada.</div>
                    )}
                  </div>
                </details>

                <details className="gerar-proposta-accordion">
                  <summary>
                    Inativos ({nivel2Resumo.inativos.length})
                  </summary>
                  <div className="gerar-proposta-accordion-body">
                    {nivel2Resumo.inativos.length > 0 ? (
                      nivel2Resumo.inativos.map((item) => (
                        <div className="gerar-proposta-item" key={item.Id || item.id}>
                          <div><b>Artigo:</b> {item.TipoArtigo || item.tipoArtigo}</div>
                          <div><b>Nascimento:</b> {this.formatarData(item.DataNascimento || item.dataNascimento)}</div>
                          <div><b>Desligamento:</b> {this.formatarData(item.DataDesligamento || item.dataDesligamento)}</div>
                          <div><b>Tempo de inatividade:</b> {item.TempoInatividade || item.tempoInatividade || 0} meses</div>
                        </div>
                      ))
                    ) : (
                      <div>Nenhum inativo informado.</div>
                    )}
                  </div>
                </details>

                <details className="gerar-proposta-accordion">
                  <summary>
                    Agregados ({nivel2Resumo.agregados.length})
                  </summary>
                  <div className="gerar-proposta-accordion-body">
                    {nivel2Resumo.agregados.length > 0 ? (
                      nivel2Resumo.agregados.map((item) => (
                        <div className="gerar-proposta-item" key={item.Id || item.id}>
                          <div><b>Vínculo:</b> {item.TipoVinculo || item.tipoVinculo}</div>
                          <div><b>Nascimento:</b> {this.formatarData(item.DataNascimento || item.dataNascimento)}</div>
                          <div><b>Idade:</b> {item.Idade || item.idade || '-'}</div>
                        </div>
                      ))
                    ) : (
                      <div>Nenhum agregado informado.</div>
                    )}
                  </div>
                </details>

                {exibirResumoReembolso && (
                  <details className="gerar-proposta-accordion">
                    <summary>
                      Reembolso diferenciado ({nivel2Resumo.reembolsos.length})
                    </summary>
                    <div className="gerar-proposta-accordion-body">
                      {reembolsosPorPlano.length > 0 ? (
                        reembolsosPorPlano.map((grupo) => (
                          <div className="gerar-proposta-item" key={grupo.planoId}>
                            <div><b>Plano:</b> {grupo.planoNome}</div>
                            {grupo.itens.map((item) => (
                              <div key={item.Id || item.id || `${grupo.planoId}_${item.EventoReembolsoCrmId || item.eventoReembolsoCrmId || item.EventoReembolsoId || item.eventoReembolsoId}`}>
                                {(item.EventoNome || item.eventoNome || item.Evento || item.evento || 'Evento')}: {this.formatarMoeda(item.Valor || item.valor || 0)}
                              </div>
                            ))}
                          </div>
                        ))
                      ) : (
                        <div>Nenhum reembolso diferenciado informado.</div>
                      )}
                    </div>
                  </details>
                )}
              </div>
            )}

            <div className="input-field col s12">
              <b>Total:</b> {totalVidas} Vidas
            </div>

            <div className="col s6 m6 l6 right-align">
              <br />
              <button type="button" onClick={() => this.voltar()} className="OmintButton">
                Voltar
              </button>
            </div>

            <div className="col s6 m6 l6 left-align">
              <br />
              <button type="button" onClick={() => this.gerarProposta()} className="OmintButton">
                Gerar&nbsp;Proposta
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
